import React from 'react'
import RegularNavigation from './RegularNavigation';
import MobileNavigation from './MobileNavigation';
function Header() {
  return (
    <>
        <RegularNavigation/>
        <MobileNavigation/>

        {/* <Logo/>
        <div>
          <div id= "header-contact">
            
            <a href="tel:781-228-8783">
            <img id= "phone-icon" src={phone} alt="" />
              <p id= "phone-number">781-228-8783</p>
              </a>
          </div>
        
        </div> */}
    </>

  )
}

export default Header;